module.exports = __webpack_public_path__ + "img/rjcpzs.0c97b8b5.jpg";